export function applyRovingTabindex(items, activeIndex) {
  items.forEach((item, index) => {
    const next = index === activeIndex ? 0 : -1;
    if (item.tabIndex !== next) {
      item.tabIndex = next;
    }
  });
}
export function focusRovingItem(items, index) {
  if (!items.length) return null;
  const next = Math.max(0, Math.min(items.length - 1, index));
  applyRovingTabindex(items, next);
  items[next]?.focus();
  return items[next] ?? null;
}
function deltaForKey(key, orientation) {
  if (key === "Home") return "first";
  if (key === "End") return "last";
  if (orientation === "horizontal") {
    if (key === "ArrowRight") return "next";
    if (key === "ArrowLeft") return "prev";
    return null;
  }
  if (key === "ArrowDown") return "next";
  if (key === "ArrowUp") return "prev";
  return null;
}
export function navigateRovingTabindex(options) {
  const {
    items,
    current,
    key,
    orientation = "horizontal",
    wrap = true
  } = options;
  if (!items.length || !current) return {
    handled: false
  };
  const index = items.indexOf(current);
  if (index < 0) return {
    handled: false
  };
  const delta = deltaForKey(key, orientation);
  if (!delta) return {
    handled: false
  };
  let next = index;
  if (delta === "first") next = 0;else if (delta === "last") next = items.length - 1;else if (delta === "next") next = wrap ? (index + 1) % items.length : Math.min(items.length - 1, index + 1);else next = wrap ? (index - 1 + items.length) % items.length : Math.max(0, index - 1);
  const item = focusRovingItem(items, next);
  if (!item) return {
    handled: false
  };
  return {
    handled: true,
    index: next,
    item
  };
}